import { createEvent, createStore } from 'effector'

import { updateMediaDataMap } from '.'

export const resetFailedMedia = createEvent('reset failed media map')
export const addFailedMedia = createEvent<string>('add failed media to map')
export const $mediaFailedAssets = createStore<Record<string, true>>(
  {},
  { name: 'map of media failed assets' },
)
  .on(addFailedMedia, (store, url) => ({
    ...store,
    [url]: true,
  }))
  .on(updateMediaDataMap, (store, medias) => {
    return medias.reduce(
      (failedMediasMap, media) => {
        if (failedMediasMap[media.files.full.url]) {
          delete failedMediasMap[media.files.full.url]
        }

        return failedMediasMap
      },
      { ...store },
    )
  })
  .reset(resetFailedMedia)
